/** @jsx jsx */

import { memo, useCallback } from 'react';

import { jsx } from '@emotion/core';

type ClickPropagationBarrierProps = {
  className?: string;
};

const ClickPropagationBarrier: React.FC<ClickPropagationBarrierProps> = memo(
  props => {
    const { children, className } = props;
    const stopPropagation = useCallback(event => {
      event.stopPropagation();
    }, []);
    return (
      <div className={className} onClick={stopPropagation} role="presentation">
        {children}
      </div>
    );
  }
);

export default ClickPropagationBarrier;
